export default __webpack_public_path__ + "static/media/Coffee.d38bde1d.svg";